"use strict";
function matchesStrictComparable(key, srcValue) {
    return function (object) {
        if (object == null) {
            return false;
        }
        return object[key] === srcValue &&
            (srcValue !== undefined || (key in Object(object)));
    };
}
module.exports = matchesStrictComparable;
//# sourceMappingURL=_matchesStrictComparable.js.map